import { css } from '@emotion/react'

import colors from './colors'

export const textAnimation = {
  angle: (color = 'var(--Colors-Sky-400)') => css`
    background: linear-gradient(-60deg, ${color} 45%, transparent 50%, ${color} 55%);
    display: inline-block;
    color: transparent;
    font-weight: 900;
    animation: angle 1.5s linear infinite;

    background-clip: text;
    -webkit-background-clip: text;
    background-size: 200%;
    background-position: 200%;

    @keyframes angle {
      to {
        background-position: 0%;
      }
    }
  `,
  wipe: (color: string = colors.primary) => css`
    background: linear-gradient(
      to right,
      transparent 20%,
      ${color} 35%,
      ${color} 50%,
      transparent 65%,
      transparent 80%
    );
    display: inline-block;
    color: transparent;
    font-weight: 900;
    animation: wipe 5s linear infinite;
    background-size: 400%;
    background-position: 400%;

    background-clip: text;

    @keyframes wipe {
      to {
        background-position: 0%;
      }
    }
  `,
  angleAndWipe: (color: string = colors.primary) => css`
    background: linear-gradient(-60deg, ${color} 45%, transparent 50%, ${color} 65%),
      linear-gradient(to right, ${color} 50%, transparent 80%, transparent 100%);
    display: inline-block;
    color: transparent;
    font-weight: 900;
    animation: angleAndWipe 4s linear infinite;
    background-size: 400%, 400%;
    background-position-x: 100%, 100%;
    background-repeat: no-repeat, no-repeat;
    background-clip: text;

    @keyframes angleAndWipe {
      48% {
        background-position-x: 0%, 100%;
      }
      50% {
        background-position-x: 0%, 100%;
        opacity: 1;
      }
      60% {
        background-position-x: 0%, 100%;
        opacity: 0;
      }
      65% {
        background-position-x: -50%, 100%;
        opacity: 0;
      }
      66.5% {
        background-position-x: -50%, 100%;
        opacity: 0;
      }
      70% {
        background-position-x: -100%, 100%;
        opacity: 1;
      }
      98% {
        background-position-x: -100%, 0%;
      }
      100% {
        background-position-x: -100%, 0%;
      }
    }
  `,
}

export const animation = {
  horizontalBounce: (
    start: number | `calc(${number}% ${'-' | '+'} ${number}px)`,
    end: number | `calc(${number}% ${'-' | '+'} ${number}px)`,
    direction: 'left' | 'right',
  ) => {
    const s = start
    const e = end
    let m: number | string = direction === 'left' ? -10 : 10

    if (typeof end !== 'number') {
      const amount = parseInt(end.match(/\d+/g)![1])
      const reg = new RegExp(`${amount}`, 'g')
      m = end.replace(reg, `${amount + m}`)
    }
    return css`
      animation: bounce-in-${direction} 0.5s ease-in-out forwards;
      @keyframes bounce-in-${direction} {
        0% {
          transform: translateX(${typeof s === 'number' ? s + 'px' : s});
        }
        50% {
          transform: translateX(${typeof e === 'number' ? e + 'px' : e});
        }
        60% {
          transform: translateX(${typeof m === 'number' ? m + 'px' : m});
        }
        100% {
          transform: translateX(${typeof e === 'number' ? e + 'px' : e});
        }
      }
    `
  },
  bounceThumb: (highestDeg = -12, lowestDeg = 12) => css`
    @keyframes bounce-thumb {
      15% {
        transform: rotate(${highestDeg + 8}deg); //-4
      }
      20% {
        transform: rotate(${highestDeg + 4}deg); //-8
      }
      23% {
        transform: rotate(${highestDeg + 2}deg); //-10
      }
      35% {
        transform: rotate(${highestDeg + 1}deg); //-11
      }
      40% {
        transform: rotate(${highestDeg + 0.5}deg); //-11.5
      }
      45% {
        transform: rotate(${highestDeg}deg);
      }
      60% {
        transform: rotate(${lowestDeg}deg);
      }
      85% {
        transform: rotate(${highestDeg * (5 / 6)}deg);
      }
      100% {
        transform: rotate(0deg);
      }
    }
    transform-origin: bottom left;
    animation: bounce-thumb 1s 1;
  `,
  pulse: css`
    animation: pulse 1.5s 1;

    @keyframes pulse {
      0% {
        transform: scale(1);
      }
      20% {
        transform: scale(1.4);
      }
      50% {
        transform: scale(0.9);
      }
      80% {
        transform: scale(1.2);
      }
      100% {
        transform: scale(1);
      }
    }
  `,
  blink: css`
    animation: blink 2s infinite linear;

    @keyframes blink {
      0% {
        opacity: 0;
      }
      10% {
        opacity: 20;
      }
      20% {
        opacity: 40;
      }
      30% {
        opacity: 60;
      }
      40% {
        opacity: 80;
      }
      50% {
        opacity: 100;
      }
      60% {
        opacity: 80;
      }
      70% {
        opacity: 60;
      }
      80% {
        opacity: 40;
      }
      90% {
        opacity: 20;
      }
      100% {
        opacity: 0;
      }
    }
  `,
}
